/*
Prakash 11/03/2022  2700912712  Added new card styles.
Prakash 11/23/2022  2700912712  Removed card component.
dilip 11/23/2022  2700912712  Added return type data API calling
*/
import React, {useContext, useEffect} from 'react';
import Tabs from './Tabs';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {getFieldType} from '../../../../redux/reducers/GlobalField/AddFieldList';
import {useDispatch} from 'react-redux';

const RuleGroup = ({setTabValue, groupId, RMbreCode}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFieldType());
  }, []);

  return (
    <>
      <div className={`${classes.cardStyleWhite}`}>
        <Tabs groupId={groupId} RMbreCode={RMbreCode} setTabValue={setTabValue} />
      </div>
    </>
  );
};

export default RuleGroup;
